// extracted by mini-css-extract-plugin
module.exports = {"grid":"TwoHalves_grid__jKbOx","flex":"TwoHalves_flex__2FLmT","gridNotEditing":"TwoHalves_gridNotEditing__224hH"};